import { render, staticRenderFns } from "./BuildingInfo.vue?vue&type=template&id=38f22624&scoped=true&"
import script from "./BuildingInfo.vue?vue&type=script&lang=js&"
export * from "./BuildingInfo.vue?vue&type=script&lang=js&"
import style1 from "./BuildingInfo.vue?vue&type=style&index=1&id=38f22624&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f22624",
  null
  
)

export default component.exports